import { render, staticRenderFns } from "./AddServiceModal.vue?vue&type=template&id=b2230bda&scoped=true&"
import script from "./AddServiceModal.vue?vue&type=script&lang=js&"
export * from "./AddServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddServiceModal.vue?vue&type=style&index=0&id=b2230bda&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2230bda",
  null
  
)

export default component.exports